import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import img_logo_color from '../../../assets/images/Logo-color.svg';
import img_logo_en_color from '../../../assets/images/logo-color-en.svg';
import img_logo_contrast from '../../../assets/images/Logo.svg';
import img_logo_en_contrast from '../../../assets/images/Logo_EN.svg';
import DropdownMenu from '../DropdownMenu';
import './Menu.css';
import $ from 'jquery';
import UE_EN_TOP_black from "../../../assets/images/UE-EN-Top-black.svg";
import UE_PL_TOP_black from "../../../assets/images/UE-PL-Top-black.svg";
import UE_EN_TOP_white from "../../../assets/images/UE-EN-Top-white.svg";
import UE_PL_TOP_white from "../../../assets/images/UE-PL-Top-white.svg";
import migamIcon from "../../../assets/images/migam.png";
import Helpers from '../../Helpers';

export default class Menu extends Component {

    constructor(props) {
        super(props);
        let data = { main_menu: [], extend_nav: [], ...props.data };
        data.main_menu = Array.isArray(data.main_menu) ? data.main_menu : JSON.parse(data.main_menu);
        data.extend_nav = Array.isArray(data.extend_nav) ? data.extend_nav : JSON.parse(data.extend_nav);
        this.state = {
            data: data,
            config: { config: [], ...props.config }
        }
    }

    toggleContrast = () => {
        const isEn = Helpers.getLanguageFromUrl() === "en";
        $("body").toggleClass("contrast-up");
        if ($("body").hasClass("contrast-up")) {
            localStorage.setItem('contrast', 'up');
            $("body.contrast-up img.gb-img-logocust-footer").attr("src", `${isEn ? img_logo_en_contrast : img_logo_contrast}`);
            $("#contrast-button").addClass("contrast-active");
        } else {
            localStorage.setItem('contrast', 'down');
            $("body img.gb-img-logocust-footer").attr("src", `${isEn ? img_logo_en_color : img_logo_color}`);
            $("#contrast-button").removeClass("contrast-active");
        }
    }

    connectArrayWithStifflyData() {
      const migamObj = {
        description: "",
        external: true,
        img: migamIcon,
        url: "https://tlumacz.migam.org/bHZPpel3nGNcowpwS7NY"
      }
      return [...this.state.data.extend_nav, migamObj];
    }

    render() {
        const isEn = Helpers.getLanguageFromUrl() === "en";
        const stifflyArr = this.connectArrayWithStifflyData();
        const logo = isEn ? img_logo_en_contrast : img_logo_contrast;
        const nifcUrl = isEn ? "https://nifc.pl/en" : "https://nifc.pl/pl";
        const digitalUrl = isEn ? "https://nauka.nifc.pl/en/programy-unijne/lista" : "https://nauka.nifc.pl/pl/programy-unijne/lista";

        const contrastClass = localStorage.getItem('contrast') === 'up' ? "contrast-active" : "";

        if (localStorage.getItem('contrast') === "up") {
            $("body").addClass("contrast-up");
        }
        if (localStorage.getItem('contrast') === "down") {
            $("body").removeClass("contrast-up");
        }

        const isBottomToolItem = (object = {}) => {
            const url = object.url || "";
            const desc = (object.description || "").trim().toLowerCase();
            if (url.includes("tlumacz.migam.org")) return true;
            if (desc) return false;
            return /^\/(pl|en)(\/.*)?$/.test(url);
        };

        const topNavItemsRaw = stifflyArr.filter((item) => !isBottomToolItem(item));
        const bottomToolItems = stifflyArr.filter((item) => isBottomToolItem(item));

        const topNavFilled = topNavItemsRaw.filter((item) => item.url || (item.description && item.description.trim()));
        const topNavEmpty = topNavItemsRaw.filter((item) => !item.url && !(item.description && item.description.trim()));
        const topNavItems = [...topNavFilled, ...topNavEmpty];

        while (topNavItems.length % 3 !== 0) {
            topNavItems.push({ url: "", description: "", external: null });
        }

        return (
            <div className="container Menu">
                <div className="row">
                    <div className="col-xs-9 col-sm-9 col-md-2 col-lg-2 newRowNifc">
                        <a href={nifcUrl}>
                            <div className="img-logocust-wrapper">
                                <img src={logo} alt="Main page of the Fryderyk Chopin Institute" className="img-responsive img-logocust" />
                            </div>
                        </a>
                    </div>
                    <div className="hidden-xs hidden-sm col-md-7 col-lg-7 extraset-item">
                        <ul className="nav navbar-nav mainmenu-list-colaps">
                            {this.state.data.main_menu.map(function (object, i) {
                                if (object.external) {
                                    return (
                                        <li className="offset-elem navel-item" key={i}>
                                            <Link to={object.url} className="offset-unit navel-unit" target="_blank" rel="noreferrer">
                                                {object.name}
                                            </Link>
                                        </li>
                                    );
                                } else {
                                    return (
                                        <li className="offset-elem navel-item" key={i}>
                                            <a href={object.url} className="offset-unit navel-unit">
                                                {object.name}
                                            </a>
                                        </li>
                                    );
                                }
                            })}
                        </ul>
                    </div>
                    <div className="col-xs-3 col-sm-3 col-md-3 col-lg-3 mobile-nav">
                        <div className="header-extentnav-wrapper">
                            <nav className="navbar navbar-default">
                                <div className="container-fluid">
                                    <DropdownMenu data={this.state.data} config={this.state.config}>
                                        <div className="navbar-header">
                                            <button type="button" className="navbar-toggle collapsed" aria-label="Toggle menu">
                                                <span className="icon-bar"></span>
                                                <span className="icon-bar"></span>
                                                <span className="icon-bar"></span>
                                            </button>
                                        </div>
                                    </DropdownMenu>

                                    <div className="navbar-collapse" id="bs-example-navbar-collapse-1">
                                        <div className="nav navbar-nav header-extentnav-holder" style={{ display: "block", width: "100%", float: "none", textAlign: "right" }}>
                                            {(() => {
                                                const rows = [];
                                                for (let r = 0; r < topNavItems.length; r += 3) {
                                                    rows.push(topNavItems.slice(r, r + 3));
                                                }
                                                return rows.map((row, ri) => (
                                                    <div className="menu-nav-row" key={`row-${ri}`} style={{ display: "flex", justifyContent: "space-between", borderBottom: "1px solid rgba(255,255,255,0.15)" }}>
                                                        {row.map((object, ci) => (
                                                            <div className="header-extendetnav-item" key={`${ri}-${ci}`} style={{ display: "block", float: "none", flex: "1 1 0", textAlign: "center" }}>
                                                                {object.url ? (
                                                                    object.hasOwnProperty('external') && object.external === true ? (
                                                                        <a href={object.url} target="_blank" rel="noreferrer" className="navel-unit">
                                                                            <div className="navel-unit-img"
                                                                                style={{
                                                                                    backgroundImage: object.img ? "url(" + object.img + ")" : "none",
                                                                                    backgroundPosition: "center", backgroundSize: "cover",
                                                                                    height: 30, textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)", color: "white", backgroundColor: "rgba(0, 0, 0, 0.02)",
                                                                                    textTransform: ["projekty ue", "eu projects"].includes((object.description || "").trim().toLowerCase()) ? "unset" : "",
                                                                                }}
                                                                                dangerouslySetInnerHTML={{ __html: `${object.description}` }}>
                                                                            </div>
                                                                        </a>
                                                                    ) : (
                                                                        <Link to={object.url} className="navel-unit">
                                                                            <div className="navel-unit-img"
                                                                                style={{ height: 30, textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)", color: "white", backgroundColor: "rgba(0, 0, 0, 0.02)" }}
                                                                                dangerouslySetInnerHTML={{ __html: object.description ? object.description : "" }}>
                                                                            </div>
                                                                        </Link>
                                                                    )
                                                                ) : (
                                                                    <div style={{ height: 30 }}></div>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                ));
                                            })()}
                                            {(() => {
                                                const migamItems = bottomToolItems.filter(o => (o.url || "").includes("tlumacz.migam.org"));
                                                const langItems = bottomToolItems.filter(o => !(o.url || "").includes("tlumacz.migam.org"));
                                                const sorted = [...migamItems, ...langItems];
                                                return (
                                                    <div className="menu-bottom-row" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingTop: 8, borderBottom: "none", width: "100%" }}>
                                                        <button id="contrast-button" className={contrastClass} onClick={this.toggleContrast} aria-label="Toggle contrast" style={{ margin: 0, padding: 0, flexShrink: 0 }}>A</button>
                                                        {sorted.map((object, i) => (
                                                            <div className="header-extendetnav-item" key={`tool-${i}`} style={{ display: "block", float: "none", borderBottom: "none", flexShrink: 0 }}>
                                                                {object.hasOwnProperty('external') && object.external === true ? (
                                                                    <a href={object.url} target="_blank" rel="noopener noreferrer" className="navel-unit" aria-label={object.description || "Migam"}>
                                                                        <div className="navel-unit-img" style={{
                                                                            backgroundImage: "url(" + object.img + ")",
                                                                            backgroundPosition: "center", backgroundSize: "contain", backgroundRepeat: "no-repeat",
                                                                            height: 32, width: 32
                                                                        }}></div>
                                                                    </a>
                                                                ) : (
                                                                    <Link to={object.url} className="navel-unit">
                                                                        <div className="navel-unit-img" style={{ height: 35, width: 35, paddingTop: 0 }}>
                                                                            <img
                                                                                src={object.img}
                                                                                alt={`toggle language button ${(object.url || "").replace(/\//g, '')}`}
                                                                                style={{ height: "100%", width: "100%", objectFit: "cover", objectPosition: "center" }}
                                                                            />
                                                                        </div>
                                                                    </Link>
                                                                )}
                                                            </div>
                                                        ))}
                                                    </div>
                                                );
                                            })()}
                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/Elements/Menu/Menu.js